import React from 'react';
import Image from 'next/image';
import { Container, Row, Col } from 'react-bootstrap';
import templateDataService from '@/services/template-data-service';
import { selectCurrentUser } from '@/stores/currentUserApi';
import { useAppSelector, type AppRootState } from '@/configureStore';
import { ToggleTax } from './Components/ToggleTax';
import styles from './Header.module.scss';
import { UserArea } from './Components/UserArea';

export const CartHeader = () => {
  const templateData = templateDataService.getTemplateData();
  const currentUser = useAppSelector((state: AppRootState) => selectCurrentUser(state));

  return (
    <>
      <header className={`${styles.cartHeader} ${styles.header}`}>
        <Container>
          <Row>
            <Col className="d-flex justify-content-end">
              <a href={'/'}>
                <Image
                  src={templateData.sector.logo}
                  alt="Carel Lurvink logo"
                  width={60}
                  height={50}
                  className={styles.cartHeaderLogo}
                  priority
                />
              </a>
              <Col xs={{ span: '5', order: 3 }} sm={{ span: 'auto', order: 3 }} className="d-block align-self-center pt-1 ml-auto">
                <UserArea user={currentUser} />
              </Col>
              <ToggleTax />
            </Col>
          </Row>
        </Container>
      </header>
    </>
  );
};
